const EARTH_RADIUS_KM = 6371;

export function haversineKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_KM * c;
}

/** Rough drive-time heuristic from straight-line km. Algarve coastal roads are twisty. */
export function estimateDriveMinutes(distanceKm: number): number {
  let avgKmh: number;
  if (distanceKm < 3) avgKmh = 28;
  else if (distanceKm < 12) avgKmh = 42;
  else if (distanceKm < 30) avgKmh = 55;
  else avgKmh = 80;
  const overheadMinutes = 3;
  return Math.round((distanceKm / avgKmh) * 60 + overheadMinutes);
}
